@for (groupsCtrl of state.form.controls; track groupsCtrl; let groupIndex = $index; let lastGroup = $last) {
  <div
    class="oo-group-container">
    <div>{{ state.dropdowns[groupIndex].label }}</div>
    <div class="oo-group-fields">
      @for (placeCtrl of groupsCtrl.controls; track placeCtrl; let placeIndex = $index) {
        <mat-form-field>
          <mat-label>{{ state.placesLabels[placeIndex] }}</mat-label>
          <mat-select [formControl]="placeCtrl">
            @for (option of state.dropdowns[groupIndex].options; track option) {
              <mat-option
                [value]="option.value">
                {{ option.name }}
              </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      }
    </div>
    @if (!lastGroup) {
      <mat-divider></mat-divider>
    }
  </div>
}
